import React from "react";
import { connect } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";

import {
    Card,
    CardHeader,
    CardBody,
    Label,
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Input
} from "reactstrap";
import { getProfileList, selectReportTitles } from "./selectors";
import {
    getTemplates,
    addTemplate,
    editTemplate,
    removeTemplate,
    getReportTitles
} from "./actions";
import moment from "moment";
import {
    Typography,
    withStyles,
    Table,
    Button,
    TableBody,
    TableHead,
    TableCell,
    TablePagination,
    TableRow
} from "@material-ui/core";
import PropTypes from "prop-types";

import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5
    }
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                    color="primary"
                >
                    {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <Button
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    color="primary"
                    aria-label="Previous Page"
                >
                    Previous Page{" "}
                    {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </Button>
                <Button
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                    color="primary"
                >
                    Next Page{" "}
                    {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </Button>
                <IconButton
                    color="primary"
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
    withTheme: true
})(TablePaginationActions);

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3
    },
    tableCell: {
        whiteSpace: "nowrap"
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: "auto",
        width: "100%;"
    },
    col12: { width: "100%" },
    col9: { width: "75%" },
    col6: { width: "50%" },

    col3: { width: "25%" },
    col2: { width: "16.66%" },
    col1: { width: "8.33%" }
});

class JobTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createModal: false,
            editModal: false,
            removeModal: false,
            template: {
                template_id: "",
                template_desc: "",
                template_title: "",
                sswp: "No"
            },
            page: 0,
            rowsPerPage: 50,
            templateObj: []
        };
        props.getTemplates();
        props.getReportTitles();
    }

    checkDate(date) {
        let momentDate = moment(date, "DD/MM/YYYY");
        let currentDate = new moment();
        let futureDate = moment().add(3, "M");
        if (momentDate.isBefore(currentDate)) {
            return "red";
        } else if (momentDate.isAfter(futureDate)) {
            return " #00e600";
        } else {
            return "#ffff00";
        }
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleTableCellsRow = list => {
        return (
            <TableCell
                style={{
                    backgroundColor: list === "No" ? "red" : "white"
                }}
            >
                {list}
            </TableCell>
        );
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    snapshotToArray = snapshot => {
        let returnArr = [];

        snapshot.forEach(childSnapshot => {
            let item = childSnapshot.val();
            item.key = childSnapshot.key;
            returnArr.push(item);
        });

        return returnArr;
    };
    render() {
        const { classes } = this.props;
        const { template } = this.state;
        const { rowsPerPage, page } = this.state;
        const list = this.props.jobTemplates === false ? [] : this.props.jobTemplates;
        const titles = this.props.reportTitles === false ? [] : this.props.reportTitles;
        return (
            <div className={classes.root} style={{ width: "100%" }}>
                <Card className={classes.tableWrapper}>
                    <CardHeader>
                        <Label className="mb-0">Template List</Label>
                    </CardHeader>
                    <CardBody>
                        <div>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TablePagination
                                            colSpan={12}
                                            ActionsComponent={TablePaginationActionsWrapped}
                                            count={list.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            rowsPerPageOptions={[50, 100]}
                                            //ActionsComponent={TablePaginationActionsWrapped}
                                        />
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className={classes.col1}>
                                            <b>Template ID</b>
                                        </TableCell>
                                        <TableCell className={classes.col1}>
                                            <b>Title</b>
                                        </TableCell>
                                        <TableCell className={classes.col2}>
                                            <b>Description</b>
                                        </TableCell>

                                        {Object.keys(titles).map((e, i) => {
                                            return (
                                                <TableCell key={i} className={classes.col1}>
                                                    <b>{titles[e]}</b>
                                                </TableCell>
                                            );
                                        })}

                                        <TableCell className={classes.col3}>
                                            <b>Actions</b>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(list)
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((e, i) => {
                                            return (
                                                <TableRow key={e}>
                                                    <TableCell component="th" scope="row">
                                                        {list[e].template_id}
                                                    </TableCell>
                                                    <TableCell>{list[e].template_title}</TableCell>
                                                    <TableCell>{list[e].template_desc}</TableCell>

                                                    {Object.keys(titles).map((ee, i) => {
                                                        return (
                                                            <TableCell
                                                                key={i}
                                                                className={classes.col1}
                                                                style={{
                                                                    backgroundColor:
                                                                        list[e][ee] === "No"
                                                                            ? "red"
                                                                            : "white"
                                                                }}
                                                            >
                                                                {list[e][ee]}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell xs={3}>
                                                        <Button
                                                            color="secondary"
                                                            style={{
                                                                border: "1px solid red",
                                                                color: "red"
                                                            }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    editModal: false,
                                                                    removeModal: true,
                                                                    createModal: false,
                                                                    template_id:
                                                                        list[e].template_id,
                                                                    template_desc:
                                                                        list[e].template_desc
                                                                });
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </Button>
                                                        <Button
                                                            color="secondary"
                                                            style={{
                                                                border: "1px solid indigo",
                                                                color: "indigo"
                                                            }}
                                                            onClick={() => {
                                                                template["template_id"] =
                                                                    list[e].template_id;
                                                                template["template_desc"] =
                                                                    list[e].template_desc;
                                                                template["template_title"] =
                                                                    list[e].template_title;

                                                                template["sswp"] = list[e]["sswp"];
                                                                this.setState({
                                                                    editModal: true,
                                                                    removeModal: false,
                                                                    createModal: false
                                                                });
                                                                Object.keys(titles).map(f => {
                                                                    template[f] = list[e][f];
                                                                    return f;
                                                                });
                                                                this.setState({
                                                                    template
                                                                });
                                                            }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </div>

                        <Button
                            color="primary"
                            style={{ marginTop: "10px" }}
                            onClick={
                                () => {
                                    this.setState({
                                        editModal: false,
                                        removeModal: false,
                                        createModal: true
                                    });
                                    template["template_id"] = "";
                                    template["template_desc"] = "";
                                    template["template_title"] = "";
                                    Object.keys(titles).map(e => {
                                        template[e] = "Yes";
                                        return e;
                                    });
                                    this.setState({ template });
                                }

                                // template:{
                                //         template_desc: "",
                                //         template_title: "",
                                //         template_ppe_inspection: "no",
                                //         template_vehicle_checklist: "no",
                                //         template_daily_worksheet: "no",
                                //         template_confined_space: "no",
                                //         template_sswp: "no"
                                //     }
                            }
                        >
                            Add
                        </Button>
                    </CardBody>
                </Card>
                <Modal isOpen={this.state.editModal}>
                    <ModalHeader>Edit Template</ModalHeader>
                    <ModalBody>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <Label for="title">Title</Label>

                                <Input
                                    id="title"
                                    value={template["template_title"]}
                                    onChange={e => {
                                        template["template_title"] = e.target.value;
                                        this.setState({ template });
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <Label for="description">Description</Label>

                                <Input
                                    id="description"
                                    value={template["template_desc"]}
                                    onChange={e => {
                                        template["template_desc"] = e.target.value;
                                        this.setState({ template });
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            {Object.keys(titles).map((f, j) => {
                                return (
                                    <Col key={j} sm="12" md="4">
                                        <Label>{titles[f]}</Label>

                                        <Input
                                            value={template[f]}
                                            type="select"
                                            onChange={e => {
                                                template[f] = e.target.value;
                                                this.setState({ template });
                                            }}
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </Col>
                                );
                            })}
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                                this.props.editTemplate(template["template_id"], template);
                                this.setState({
                                    template: []
                                });
                            }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.createModal}>
                    <ModalHeader>Add Template</ModalHeader>
                    <ModalBody>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <Label for="title">Title</Label>

                                <Input
                                    id="title"
                                    value={template["template_title"]}
                                    onChange={e => {
                                        template["template_title"] = e.target.value;
                                        this.setState({ template });
                                    }}
                                />
                            </Col>
                            <Col>
                                <Label for="description">Description</Label>

                                <Input
                                    id="description"
                                    value={template["template_desc"]}
                                    onChange={e => {
                                        template["template_desc"] = e.target.value;
                                        this.setState({ template });
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: "10px" }}>
                            {Object.keys(titles).map((f, j) => {
                                return (
                                    <Col key={j} sm="12" md="4">
                                        <Label for="form">{titles[f]}</Label>

                                        <Input
                                            id="form"
                                            value={template[f]}
                                            type="select"
                                            onChange={e => {
                                                template[f] = e.target.value;
                                                this.setState({ template });
                                            }}
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </Col>
                                );
                            })}
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });

                                this.props.addTemplate(this.state.template);
                                this.setState({
                                    template: []
                                });
                            }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.removeModal}>
                    <ModalHeader>Remove Template</ModalHeader>
                    <ModalBody>
                        <Typography>Are you sure you want to remove this Job Template?</Typography>
                        <Row>
                            <Col>
                                <Label>Template Title</Label>

                                <p>
                                    <b>{this.state.template_title}</b>
                                </p>
                            </Col>
                            <Col>
                                <Label>Template Description</Label>
                                <p>
                                    <b>{this.state.template_desc}</b>
                                </p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                                this.props.removeTemplate(this.state.template_id);
                                this.setState({ template_id: "" });
                            }}
                        >
                            Remove
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default connect(
    store => {
        return {
            reportTitles: selectReportTitles(store),
            jobTemplates: getProfileList(store)
        };
    },
    { getTemplates, addTemplate, editTemplate, removeTemplate, getReportTitles }
)(withStyles(styles)(JobTemplate));
